import * as React from 'react';
import { FrameBackgroundContent } from '../../components';
import { ContentfulFrame } from '../../interfaces';
import { startPageAnimation } from '../../utils/page-animation-queue';
import './frame-page-display.scss';
import { CONTENTS } from './frame-page-display-properties';

const addHash = (color: string) => (color[0] === '#' ? color : `#${color}`);
const getStyle = (frame: ContentfulFrame) =>
  frame.backgroundColor ? { backgroundColor: addHash(frame.backgroundColor) } : undefined;

export interface FrameProperties {
  frame: ContentfulFrame;
  index: number;
  isLastFrame: boolean;
  useDarkTheme: boolean;
  showScrollIndicator: boolean;
  hasUnsetWidth: boolean;
}

export class FrameDisplay extends React.PureComponent<FrameProperties> {
  componentDidMount() {
    setTimeout(startPageAnimation, 500);
  }

  render() {
    const { frame, index, isLastFrame, useDarkTheme, showScrollIndicator, hasUnsetWidth } =
      this.props;

    return (
      <div
        className={`frame ${isLastFrame ? 'frame--last' : ''} ${useDarkTheme ? 'theme-dark' : ''} ${
          index === 0 ? 'frame--first frame--active' : ''
        }${frame.backgroundParallax ? 'background-parallax' : ''}`}
        style={{
          backgroundImage:
            frame.backgroundParallax && frame.backgroundImage
              ? 'url(' + frame.backgroundImage.file.url + ')'
              : undefined,
        }}
      >
        <div className="frame-background" style={getStyle(frame)}>
          <FrameBackgroundContent
            video={frame.backgroundVideo}
            image={frame.backgroundImage}
            staticBackground={!frame.backgroundParallax}
          />
        </div>
        <div className={`frame-content ${hasUnsetWidth ? '' : 'frame-content-width'} `}>
          {frame.contents &&
            frame.contents.map((item, i) => {
              switch (item.__typename) {
                case 'ContentfulCarousel': {
                  const { Component, mapProps } = CONTENTS[item.__typename];
                  return <Component key={i} {...mapProps(item, {})} />;
                }
                case 'ContentfulContent': {
                  const { Component, mapProps } = CONTENTS[item.__typename];
                  return <Component key={i} {...mapProps(item, { index })} />;
                }
                case 'ContentfulCtaPopUp': {
                  const { Component, mapProps } = CONTENTS[item.__typename];
                  return <Component key={i} {...mapProps(item, {})} />;
                }
                default:
                  return null;
              }
            })}
          {showScrollIndicator && (
            <div className="frame-homepage-scroll-indicator">
              <img
                alt="scroll indicator"
                src={require('../../assets/home_scroll_indicator.svg').default}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}
